import React from "react";
import {useTranslation} from "react-i18next";
import {TableLabelCell, TableLabelHeader} from "../../common/CustomTable/CustomTable";
import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceTable from "../ThirdPartyServiceTable";

function GraphServiceTable(props) {

    return (
        <ThirdPartyServiceTable {...props} type={ThirdPartyServiceModel.Type.GRAPH} showMethod
            TableHeaders={GraphServiceTableHeaders} TableRowCells={GraphServiceTableRowCells}
        />
    )
}

function GraphServiceTableHeaders() {
    const {t} = useTranslation(['thirdPartyService']);
    return (
        <>
            <TableLabelHeader label={t('thirdPartyService:label.url')}/>
        </>
    )
}

function GraphServiceTableRowCells(props) {
    const {
        thirdPartyService
    } = props;

    return (
        <>
            <TableLabelCell label={thirdPartyService.url}/>
        </>
    )
}

export default GraphServiceTable;
